import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fuerzasApi, userApi, profileApi, apiError, logout, mediaUrl } from "../lib/api";
import { NotificationBell } from "../components/NotificationBell";
import { AnaPanel } from "../components/ana/AnaPanel";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../components/ui/dialog";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Textarea } from "../components/ui/textarea";
import { toast } from "sonner";
import { Diamond, LogOut, Video, MessagesSquare, Wallet, Footprints, BookOpen, Globe2, ListChecks, Clapperboard, Radio, Rocket, CalendarClock, Camera, KeyRound, Trash2, Plus, Download } from "lucide-react";

const IMG = {
  clases: "https://static.prod-images.emergentagent.com/jobs/c09f4645-686d-4e1e-a0f6-b7743ec7133b/images/37c8d61d7e0e3b059b07521c442674ac79c3f6131a4ea5ff38ffaba96097c1f0.jpeg",
  carrera: "https://static.prod-images.emergentagent.com/jobs/c09f4645-686d-4e1e-a0f6-b7743ec7133b/images/0ffeb225ef16410980ce57dc75f22371c0c07b706695ab9907f3f2926ee3dcb3.jpeg",
  libro: "https://static.prod-images.emergentagent.com/jobs/c09f4645-686d-4e1e-a0f6-b7743ec7133b/images/7f8af6db4ac098a8e91d1dc22fdae1fe9b4bc842fa852ca801eb6f433d0942fe.jpeg",
  influencia: "https://static.prod-images.emergentagent.com/jobs/c09f4645-686d-4e1e-a0f6-b7743ec7133b/images/479d821cbba8df05652e9dad18a6c18ebfdb60506e7944799fc56e0632309331.jpeg",
  acciones: "https://static.prod-images.emergentagent.com/jobs/c09f4645-686d-4e1e-a0f6-b7743ec7133b/images/2eccb036961647e889cc25a9aa68100f735afdb55c4f6ec0d7a43f749a7426e2.jpeg",
  videos: "https://static.prod-images.emergentagent.com/jobs/c09f4645-686d-4e1e-a0f6-b7743ec7133b/images/6017f2a9b8a53d617303800fbbfc2ce7949a6abc2c37d5bea0f95cb768165373.jpeg",
  lives: "https://static.prod-images.emergentagent.com/jobs/c09f4645-686d-4e1e-a0f6-b7743ec7133b/images/3758bbec8dc98c4cf9e682b163f45ec1106692281b0c63dad7e5b70dda268b0b.jpeg",
  expansion: "https://static.prod-images.emergentagent.com/jobs/c09f4645-686d-4e1e-a0f6-b7743ec7133b/images/3fec7d65d72c7688da10b11379297619255651a179df5da1f6d511f6eb5191e1.jpeg",
};

export default function CoachPanel() {
  const navigate = useNavigate();
  const [d, setD] = useState(null);
  const [frase, setFrase] = useState("");
  const [open, setOpen] = useState(null);
  const load = () => fuerzasApi.me().then(setD).catch((e) => toast.error(apiError(e)));
  useEffect(() => { load(); userApi.fraseDia().then((f) => setFrase(f?.texto || f?.frase || "")).catch(() => {}); }, []);
  const p = d?.perfil;

  const TILES = [
    { key: "connect", label: "Supera Connect", img: IMG.clases, icon: Video, go: () => navigate("/connect") },
    { key: "chat", label: "Chat Supera", img: IMG.clases, icon: MessagesSquare, go: () => navigate("/chat") },
    { key: "financiamiento", label: "Financiamiento", img: IMG.expansion, icon: Wallet, go: () => navigate("/financiamiento") },
    { key: "carrera", label: "Carrera Supera", img: IMG.carrera, icon: Footprints, go: () => navigate("/carrera") },
    { key: "libro", label: "El Libro", img: IMG.libro, icon: BookOpen, go: () => navigate("/campus") },
    { key: "nexus", label: "Supera Nexus", img: IMG.clases, icon: CalendarClock, go: () => navigate("/nexus") },
    { key: "influencia", label: "Influencia en el Mundo", img: IMG.influencia, icon: Globe2, go: () => setOpen("influencia") },
    { key: "acciones", label: "Acciones Diarias", img: IMG.acciones, icon: ListChecks, go: () => setOpen("acciones") },
    { key: "videos", label: "Videos Express", img: IMG.videos, icon: Clapperboard, go: () => setOpen("videos") },
    { key: "lives", label: "Lives Supera", img: IMG.lives, icon: Radio, go: () => setOpen("lives") },
    { key: "expansion", label: "Expansión Supera", img: IMG.expansion, icon: Rocket, go: () => setOpen("expansion") },
  ];

  return (
    <div className="min-h-screen bg-[#0A1C30] text-white" data-testid="coach-panel">
      <header className="sticky top-0 z-20 bg-[#0A1C30]/95 backdrop-blur border-b border-white/10">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
          <div className="flex items-center gap-2"><Diamond className="w-5 h-5 text-[var(--gold)] fill-[var(--gold)]" /><span className="font-extrabold tracking-[0.3em]">SUPERA</span></div>
          <div className="flex items-center gap-3">
            <NotificationBell />
            <button onClick={() => setOpen("perfil")} data-testid="coach-perfil-btn" className="flex items-center gap-2">
              {p?.avatar_url ? <img src={mediaUrl(p.avatar_url)} alt="" className="w-9 h-9 rounded-full object-cover ring-2 ring-[var(--gold)]" /> : <div className="w-9 h-9 rounded-full bg-white/10 grid place-items-center font-bold">{(p?.nombre || "?")[0]}</div>}
              <span className="text-sm font-bold hidden sm:inline">{p?.nombre}</span>
            </button>
            <button onClick={() => { logout(); navigate("/login"); }} data-testid="coach-logout" className="text-white/60 hover:text-white"><LogOut className="w-5 h-5" /></button>
          </div>
        </div>
      </header>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 pt-6"><AnaPanel /></div>

      {frase && (
        <div className="max-w-6xl mx-auto px-4 sm:px-6 pt-6" data-testid="coach-frase">
          <div className="rounded-2xl bg-[var(--gold)]/10 ring-1 ring-[var(--gold)]/30 px-5 py-4 text-[var(--gold)] font-semibold italic">“{frase}”</div>
        </div>
      )}

      <section className="max-w-6xl mx-auto px-4 sm:px-6 pt-6 pb-4">
        <p className="text-[var(--gold)] font-bold tracking-widest text-xs uppercase mb-2">{p?.programa}</p>
        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold leading-tight">¡Hola, {p?.nombre || ""}!</h1>
        <p className="text-white/60 mt-3 max-w-2xl">Tu espacio como líder Supera. Conéctate a tus clases, entrena, influye en el mundo y haz crecer el movimiento.</p>
      </section>

      <section className="max-w-6xl mx-auto px-4 sm:px-6 pb-16">
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
          {TILES.map((t, i) => {
            const Icon = t.icon;
            return (
              <button key={t.key} data-testid={`coach-tile-${t.key}`} onClick={t.go}
                className="group relative overflow-hidden rounded-2xl ring-1 ring-white/10 text-left aspect-[4/3] transition-transform hover:-translate-y-1"
                style={{ animation: `fadeUp .5s ease ${i * 0.05}s both` }}>
                <img src={t.img} alt="" className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0A1C30] via-[#0A1C30]/50 to-transparent" />
                <div className="absolute inset-0 p-4 sm:p-5 flex flex-col justify-end">
                  <div className="w-10 h-10 rounded-xl bg-[var(--gold)] grid place-items-center mb-2"><Icon className="w-5 h-5 text-[#0A1C30]" /></div>
                  <p className="font-extrabold text-base sm:text-lg leading-tight">{t.label}</p>
                </div>
              </button>
            );
          })}
        </div>
      </section>

      {open === "influencia" && <InfluenciaModal data={d.influencia} onClose={() => setOpen(null)} onChanged={load} />}
      {open === "acciones" && <AccionesModal items={d.acciones_diarias} onClose={() => setOpen(null)} onChanged={load} />}
      {open === "videos" && <VideosModal items={d.videos} onClose={() => setOpen(null)} />}
      {open === "lives" && <LivesModal items={d.lives} instagram={d.instagram_url} onClose={() => setOpen(null)} onChanged={load} />}
      {open === "expansion" && <ExpansionModal items={d.expansion} onClose={() => setOpen(null)} onChanged={load} />}
      {open === "perfil" && <PerfilModal perfil={p} onClose={() => setOpen(null)} onSaved={() => { setOpen(null); load(); }} />}
      <style>{`@keyframes fadeUp{from{opacity:0;transform:translateY(16px)}to{opacity:1;transform:translateY(0)}}`}</style>
    </div>
  );
}

function Modal({ title, desc, testid, children }) {
  return (
    <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto" data-testid={testid}>
      <DialogHeader><DialogTitle>{title}</DialogTitle><DialogDescription>{desc}</DialogDescription></DialogHeader>
      {children}
    </DialogContent>
  );
}

function InfluenciaModal({ data, onClose, onChanged }) {
  const [plan, setPlan] = useState(data.plan || "");
  const [a, setA] = useState({ accion: "", resultado: "", personas: 0 });
  const savePlan = async () => { try { await fuerzasApi.savePlan(plan); toast.success("Plan guardado."); onChanged(); } catch (e) { toast.error(apiError(e)); } };
  const addAccion = async () => { if (!a.accion.trim()) { toast.error("Escribe la acción."); return; } try { await fuerzasApi.addAccion({ ...a, personas: Number(a.personas) || 0 }); setA({ accion: "", resultado: "", personas: 0 }); onChanged(); } catch (e) { toast.error(apiError(e)); } };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <Modal title="Influencia en el Mundo" desc="Tu plan de liderazgo y el impacto que estás generando." testid="coach-modal-influencia">
        <div className="rounded-xl bg-[#F4F6F9] p-4 mb-4">
          <Label className="text-xs font-bold">Mi plan: ¿cómo voy a influir positivamente en el mundo con mi liderazgo?</Label>
          <Textarea data-testid="inf-plan" rows={3} value={plan} onChange={(e) => setPlan(e.target.value)} className="mt-1" />
          <button data-testid="inf-plan-save" onClick={savePlan} className="mt-2 rounded-lg bg-navy text-white font-bold px-4 py-2 text-sm">Guardar plan</button>
        </div>
        <div className="rounded-xl ring-1 ring-black/10 p-4 mb-3">
          <p className="font-bold text-[#0A1C30] mb-2">Registrar acción de liderazgo</p>
          <div className="space-y-2">
            <Input placeholder="Acción concreta" value={a.accion} onChange={(e) => setA((s) => ({ ...s, accion: e.target.value }))} />
            <Input placeholder="Resultado obtenido" value={a.resultado} onChange={(e) => setA((s) => ({ ...s, resultado: e.target.value }))} />
            <div className="flex items-center gap-2"><Label className="text-xs font-bold whitespace-nowrap">Personas influidas</Label><Input type="number" className="w-28" value={a.personas} onChange={(e) => setA((s) => ({ ...s, personas: e.target.value }))} /><button data-testid="inf-accion-add" onClick={addAccion} className="ml-auto rounded-lg bg-[var(--gold)] text-[#0A1C30] font-bold px-4 py-2 text-sm">Agregar</button></div>
          </div>
        </div>
        <p className="text-sm font-bold text-[#0A1C30] mb-2">Personas influidas en total: <span className="text-[#177A45]">{data.total_personas}</span></p>
        <div className="space-y-2">
          {data.acciones.map((it) => (
            <div key={it.id} className="flex items-start justify-between gap-2 rounded-lg bg-[#F4F6F9] p-3">
              <div><p className="font-bold text-sm text-[#0A1C30]">{it.accion}</p><p className="text-xs text-[#6B7688]">{it.resultado} · {it.personas} personas</p></div>
              <button onClick={async () => { await fuerzasApi.delAccion(it.id); onChanged(); }} className="text-[#C0392B] p-1"><Trash2 className="w-4 h-4" /></button>
            </div>
          ))}
        </div>
      </Modal>
    </Dialog>
  );
}

function AccionesModal({ items, onClose, onChanged }) {
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <Modal title="Acciones Diarias" desc="Actividades que Supera preparó para ti. Márcalas al completarlas." testid="coach-modal-acciones">
        <div className="space-y-2">
          {items.length === 0 && <p className="text-sm text-[#6B7688] py-6 text-center">Aún no tienes acciones asignadas.</p>}
          {items.map((it) => (
            <label key={it.id} className="flex items-start gap-3 rounded-lg bg-[#F4F6F9] p-3 cursor-pointer">
              <input type="checkbox" checked={!!it.completada} onChange={async () => { await fuerzasApi.toggleDiaria(it.id); onChanged(); }} className="mt-1" data-testid={`accion-check-${it.id}`} />
              <div><p className={`font-bold text-sm ${it.completada ? "line-through text-[#9AA3B2]" : "text-[#0A1C30]"}`}>{it.titulo}</p>{it.fecha && <p className="text-xs text-[#6B7688]">{it.fecha}</p>}{it.descripcion && <p className="text-sm text-[#3B4658]">{it.descripcion}</p>}</div>
            </label>
          ))}
        </div>
      </Modal>
    </Dialog>
  );
}

function VideosModal({ items, onClose }) {
  const openVid = async (v) => {
    if (v.link) { window.open(v.link, "_blank"); return; }
    try { const b = await fuerzasApi.videoBlob(v.id); const url = URL.createObjectURL(b); window.open(url, "_blank"); setTimeout(() => URL.revokeObjectURL(url), 120000); } catch (e) { toast.error(apiError(e)); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <Modal title="Videos Express" desc="Cápsulas cortas de Supera para ti." testid="coach-modal-videos">
        <div className="space-y-2">
          {items.length === 0 && <p className="text-sm text-[#6B7688] py-6 text-center">Aún no hay videos.</p>}
          {items.map((v) => (
            <div key={v.id} className="flex items-center justify-between gap-2 rounded-lg bg-[#F4F6F9] p-3">
              <div><p className="font-bold text-sm text-[#0A1C30]">{v.titulo}</p>{v.descripcion && <p className="text-xs text-[#6B7688]">{v.descripcion}</p>}</div>
              {(v.link || v.tiene_archivo) && <button onClick={() => openVid(v)} className="rounded-lg bg-navy text-white font-bold px-3 py-1.5 text-xs flex items-center gap-1.5"><Video className="w-3.5 h-3.5" /> Ver</button>}
            </div>
          ))}
        </div>
      </Modal>
    </Dialog>
  );
}

function LivesModal({ items, instagram, onClose, onChanged }) {
  const [f, setF] = useState({ nombre: "", apellido: "", fecha: "", whatsapp: "" });
  const add = async () => { if (!f.nombre.trim() || !f.fecha) { toast.error("Escribe tu nombre y la fecha."); return; } try { await fuerzasApi.addLive(f); setF({ nombre: "", apellido: "", fecha: "", whatsapp: "" }); toast.success("Live reservado."); onChanged(); } catch (e) { toast.error(apiError(e)); } };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <Modal title="Lives Supera" desc="Conéctate a Instagram para transmitir en vivo y reserva tu fecha." testid="coach-modal-lives">
        <a href={instagram} target="_blank" rel="noreferrer" data-testid="lives-ig-link" className="flex items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-[#C13584] to-[#F56040] text-white font-extrabold px-5 py-3 mb-4"><Radio className="w-5 h-5" /> Ir a Instagram para hacer tu Live</a>
        <div className="rounded-xl ring-1 ring-black/10 p-4 mb-3">
          <p className="font-bold text-[#0A1C30] mb-2">Reservar mi live</p>
          <div className="grid grid-cols-2 gap-2">
            <Input placeholder="Nombre" value={f.nombre} onChange={(e) => setF((s) => ({ ...s, nombre: e.target.value }))} data-testid="live-nombre" />
            <Input placeholder="Apellido" value={f.apellido} onChange={(e) => setF((s) => ({ ...s, apellido: e.target.value }))} />
            <Input type="datetime-local" value={f.fecha} onChange={(e) => setF((s) => ({ ...s, fecha: e.target.value }))} data-testid="live-fecha" />
            <Input placeholder="WhatsApp de contacto" value={f.whatsapp} onChange={(e) => setF((s) => ({ ...s, whatsapp: e.target.value }))} />
          </div>
          <button data-testid="live-add" onClick={add} className="mt-2 rounded-lg bg-[var(--gold)] text-[#0A1C30] font-bold px-4 py-2 text-sm">Reservar</button>
        </div>
        <div className="space-y-2">
          {items.map((l) => (
            <div key={l.id} className="flex items-center justify-between rounded-lg bg-[#F4F6F9] p-3">
              <div><p className="font-bold text-sm text-[#0A1C30]">{l.nombre} {l.apellido}</p><p className="text-xs text-[#6B7688]">{l.fecha ? new Date(l.fecha).toLocaleString() : ""} · {l.whatsapp}</p></div>
              <button onClick={async () => { await fuerzasApi.delLive(l.id); onChanged(); }} className="text-[#C0392B] p-1"><Trash2 className="w-4 h-4" /></button>
            </div>
          ))}
        </div>
      </Modal>
    </Dialog>
  );
}

function ExpansionModal({ items, onClose, onChanged }) {
  const [f, setF] = useState({ tipo: "Colegio", institucion: "", contacto_nombre: "", cargo: "", telefono: "", email: "", notas: "" });
  const set = (k, v) => setF((s) => ({ ...s, [k]: v }));
  const add = async () => { if (!f.institucion.trim() && !f.contacto_nombre.trim()) { toast.error("Indica el colegio o el contacto."); return; } try { await fuerzasApi.addExpansion(f); setF({ tipo: "Colegio", institucion: "", contacto_nombre: "", cargo: "", telefono: "", email: "", notas: "" }); toast.success("Contacto enviado a Supera."); onChanged(); } catch (e) { toast.error(apiError(e)); } };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <Modal title="Expansión Supera" desc="Comparte contactos de colegios o directores para hacer crecer el movimiento." testid="coach-modal-expansion">
        <div className="rounded-xl ring-1 ring-black/10 p-4 mb-3 space-y-2">
          <div className="grid grid-cols-2 gap-2">
            <select className="h-9 rounded-md border border-black/10 px-2 text-sm bg-white" value={f.tipo} onChange={(e) => set("tipo", e.target.value)}><option>Colegio</option><option>Director</option><option>Contacto especial</option></select>
            <Input placeholder="Colegio / institución" value={f.institucion} onChange={(e) => set("institucion", e.target.value)} data-testid="exp-institucion" />
            <Input placeholder="Nombre del contacto" value={f.contacto_nombre} onChange={(e) => set("contacto_nombre", e.target.value)} />
            <Input placeholder="Cargo" value={f.cargo} onChange={(e) => set("cargo", e.target.value)} />
            <Input placeholder="Teléfono" value={f.telefono} onChange={(e) => set("telefono", e.target.value)} />
            <Input placeholder="Correo" value={f.email} onChange={(e) => set("email", e.target.value)} />
          </div>
          <Textarea placeholder="Notas" rows={2} value={f.notas} onChange={(e) => set("notas", e.target.value)} />
          <button data-testid="exp-add" onClick={add} className="rounded-lg bg-[var(--gold)] text-[#0A1C30] font-bold px-4 py-2 text-sm">Enviar contacto</button>
        </div>
        <div className="space-y-2">
          {items.map((x) => (
            <div key={x.id} className="flex items-center justify-between rounded-lg bg-[#F4F6F9] p-3">
              <div><p className="font-bold text-sm text-[#0A1C30]">{x.institucion || x.contacto_nombre} <span className="text-xs text-[#6B7688]">({x.tipo})</span></p><p className="text-xs text-[#6B7688]">{x.contacto_nombre}{x.cargo ? ` · ${x.cargo}` : ""}{x.telefono ? ` · ${x.telefono}` : ""}</p></div>
              <button onClick={async () => { await fuerzasApi.delExpansion(x.id); onChanged(); }} className="text-[#C0392B] p-1"><Trash2 className="w-4 h-4" /></button>
            </div>
          ))}
        </div>
      </Modal>
    </Dialog>
  );
}

function PerfilModal({ perfil, onClose, onSaved }) {
  const [pw, setPw] = useState({ current_password: "", new_password: "" });
  const changePw = async () => { if (!pw.current_password || !pw.new_password) { toast.error("Completa ambas contraseñas."); return; } try { await profileApi.changePassword(pw.current_password, pw.new_password); toast.success("Contraseña actualizada."); setPw({ current_password: "", new_password: "" }); } catch (e) { toast.error(apiError(e)); } };
  const uploadAvatar = async (file) => { if (!file) return; try { await profileApi.uploadAvatar(file); toast.success("Foto actualizada."); onSaved(); } catch (e) { toast.error(apiError(e)); } };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <Modal title="Mi perfil" desc="Tu información Supera. El nombre solo lo cambia Supera." testid="coach-perfil-modal">
        <div className="flex items-center gap-3 mb-3">
          {perfil?.avatar_url ? <img src={mediaUrl(perfil.avatar_url)} alt="" className="w-16 h-16 rounded-full object-cover ring-2 ring-[var(--gold)]" /> : <div className="w-16 h-16 rounded-full bg-navy grid place-items-center text-white font-bold text-xl">{(perfil?.nombre || "?")[0]}</div>}
          <label className="flex items-center gap-1.5 text-sm font-bold text-navy cursor-pointer"><Camera className="w-4 h-4" /> Cambiar foto<input type="file" accept="image/*" className="hidden" onChange={(e) => uploadAvatar(e.target.files[0])} /></label>
        </div>
        <div className="grid grid-cols-2 gap-3 text-sm">
          <div><Label className="text-xs font-bold">Nombre</Label><Input value={perfil?.nombre || ""} disabled /></div>
          <div><Label className="text-xs font-bold">Apellidos</Label><Input value={perfil?.apellidos || ""} disabled /></div>
          <div><Label className="text-xs font-bold">Programa</Label><Input value={perfil?.programa || ""} disabled /></div>
          <div><Label className="text-xs font-bold">Referencia</Label><Input value={perfil?.referencia || ""} disabled /></div>
          <div className="col-span-2"><Label className="text-xs font-bold">Correo</Label><Input value={perfil?.email || ""} disabled /></div>
        </div>
        <div className="rounded-xl ring-1 ring-black/10 p-4 mt-3">
          <p className="font-bold text-[#0A1C30] text-sm mb-2 flex items-center gap-1.5"><KeyRound className="w-4 h-4" /> Cambiar contraseña</p>
          <div className="space-y-2">
            <Input type="password" placeholder="Contraseña actual" value={pw.current_password} onChange={(e) => setPw((s) => ({ ...s, current_password: e.target.value }))} />
            <Input type="password" placeholder="Nueva contraseña" value={pw.new_password} onChange={(e) => setPw((s) => ({ ...s, new_password: e.target.value }))} />
            <button data-testid="coach-pw-save" onClick={changePw} className="rounded-lg bg-navy text-white font-bold px-4 py-2 text-sm">Actualizar contraseña</button>
          </div>
        </div>
      </Modal>
    </Dialog>
  );
}
